// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"9de2a636","275":"ccf45fa6","377":"3f61dae7","814":"4a5a5884"}[chunkId] + ".chunk.js";
};